export default "__VITE_ASSET__DsE8Gnpn__"